<template>
    <div>
        <div class="tbfh">
            <div class="fjsf bit-center-wrap" @click="$nav.back()">
                <i class="el-icon-arrow-left" style="color: rgb(170, 170, 170);"></i>
                <span class="ted">
                    <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">{{ $t('提币') }}</font>
                    </font>
                </span>
            </div>
        </div>

        <div class="box">
            <div style="display: flex;justify-content: space-between;">
                <div class="content_TK bg-main">
                    <el-form label-position="top" label-width="80px" :model="form">
                        <el-form-item :label="$t('选择币种')">
                            <el-select v-model="form.payment_id" :placeholder="$t('请选择')" style="width: 100%;">
                                <el-option v-for="item in columns" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('提现地址')">
                            <el-input v-model="form.address"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('数量')">
                            <el-input v-model="form.amount">
                                <template slot="suffix">
                                    <div class="dad" @click="allCk">{{ $t('全部') }}</div>
                                </template>
                            </el-input>
                            <div style="padding-top: 8px;color: #999999;">{{$t('可用')}}：{{ money }} USDT</div>
                        </el-form-item>
                        <el-form-item :label="$t('手续费')">
                            <el-input v-model="form.sxf" disabled></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('到账金额')">
                            <el-input v-model="form.dzje" disabled></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('资金密码')">
                            <el-input v-model="form.pay_password" type="password"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="sdafasdf" @click="carryTb">{{ $t('提现') }}</div>
                </div>

                <div class="right">
                    <img src="@/assets/img-pc/change_7.png" />
                    <div class="tips-back">
                        <div class="flex-v-c">
                            <img src="@/assets/img-pc/change_8.png" class="notice-img" />
                            <span class="fsfs">
                                <font dir="auto" style="vertical-align: inherit;">
                                    <font dir="auto" style="vertical-align: inherit;">{{ $t('重要通知') }}</font>
                                </font>
                            </span>
                        </div>
                        <div class="content" v-html="content">
                        </div>
                    </div>
                </div>
            </div>
            <div class="infosty bg-main">
                <div class="titlesty">
                    <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">{{ $t('记录') }}</font>
                    </font>
                </div>

                <div class="MetaTrader5-bottom-content">
                    <div class="trend-head">
                        <div class="column"> {{ $t('货币') }} </div>
                        <div class="column"> {{ $t('提币金额') }} </div>
                        <div class="column"> {{ $t('状态') }} </div>
                        <div class="column"> {{ $t('创建时间') }} </div>
                    </div>
                    <div class="scroll-wrap">
                        <ul class="trend-body">
                            <li class="row" v-for="item in list" :key="item.id">
                                <div class="column">{{ item.payment_name }}</div>
                                <div class="column">{{ item.amount }}</div>
                                <div class="column">{{ item.status_text }}</div>
                                <div class="column">{{ item.createtime_text }}</div>
                            </li>
                        </ul>
                    </div>
                </div>

                <oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
                    :total="page.total" @current-change="withdrawList" />
            </div>
        </div>
    </div>
</template>
<script>
import { get, post } from '@/http/request'
import apis from '@/http/api'
import oPage from '@/common/pc/oPage.vue'

const USDT = 'USDT'
export default {
    components: {
        oPage
    },
    data() {
        return {
            columns: [],
            list: [],
            content: '',
            money: '',

            form: {
                amount: '', //投资金额
                pay_password: '', //支付密码
                address: '',// 地址
                payment_id: '',// 通道id

                sxf: `0.00 ${USDT}`,
                dzje: '0.00',
            },
            page: {
                page: 1,
                limit: 10,
                total: 100,
            }
        };
    },
    mounted() {
        this.withdrawData()
        this.withdrawList()
        this.addressList()
        this.getUserInfo()
    },
    computed: {

    },
    watch: {
        "form.payment_id"(id) {
            if (!Array.isArray(this.columns)) return
            let paymen = this.columns.filter(item => item.id == id)[0]
            // console.log(paymen.rate)
            this.form.sxf = paymen.withdraw_fee + ` ${USDT}`
            this.form.dzje = ((this.form.amount - paymen.withdraw_fee) / paymen.rate).toFixed(2)
        },

        "form.amount"(val) {
            if (!Array.isArray(this.columns)) return
            let paymen = this.columns.filter(item => item.id == this.form.payment_id)[0]
            if (val < 0) {
                this.form.dzje = paymen.min_withdraw || '0.00'
            } else if (val > paymen.max_withdraw) {
                this.form.dzje = paymen.max_withdraw || '0.00'
            } else {
                this.form.dzje = ((val - paymen.withdraw_fee) / paymen.rate).toFixed(2)
            }
        },
    },
    methods: {
        async withdrawData() {
            const res = await get(apis.withdrawData, { showLoading: false })
            if (res.code == 1) {
                this.content = res.data.content
                return
            }
        },
        //提现币种
        async addressList() {
            const res = await get(apis.addressList, { showLoading: false })
            if (res.code == 1) {
                this.columns = res.data.payment || []
                if (this.columns.length > 0) {
                    this.form.payment_id = this.columns[0].id
                }
            }
        },
        //提现记录
        async withdrawList() {
            const res = await get(apis.withdrawList, { ...this.page })
            if (res.code == 1) {
                this.list = res.data.data
                this.page.total = res.data.total
            }
        },
        //
        async getUserInfo() {
            const res = await get(apis.getUserInfo, { showLoading: false })
            if (res.code == 1) {
                this.money = res.data.money
                return
            }
        },
        //提币
        async carryTb() {
            const res = await post(apis.withdrawSubmit, {
                ...this.form
            })
            if (res.code == 1) {
                this.quantity = ''
                this.page.page = 1
                this.withdrawList()
                this.getUserInfo()
                this.$notify.success(res.msg);
                return
            }

        },
        //全部
        allCk() {
            this.form.amount = this.money
        },
    },
}
</script>
<style lang="scss" scoped>
::v-deep .el-form--label-top .el-form-item__label {
    padding: 0 0 5px 0;
}

::v-deep .el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
}

.tbfh {
    width: 100%;
    padding: 32px 0;
    background: #090d13;
    margin-bottom: 48px;
}

.fjsf {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 1.875rem;
}

.bit-center-wrap {
    width: 1360px;
    max-width: 90%;
    margin: 0 auto;
}

.ted {
    font-weight: 700;
    color: #fff;
}

.box {
    width: 1200px;
    margin: 0 auto;
    color: #000;
    margin-bottom: 50px;

    .bg-main {
        background: none;
    }

    .content_TK {
        width: 480px;
        border-radius: 5px;
    }

    .right {
        width: 480px;

        .tips-back {
            margin-top: 48px;
            border-radius: 10px;
            background-color: #171d28;
            padding: 39px 27px 48px;

            .flex-v-c {
                display: flex;
                align-items: center;
                margin-bottom: 28px;

                .notice-img {
                    width: 24px;
                    height: 22px;
                    margin-right: 10px;
                }

                .fsfs {
                    font-size: 20px;
                    font-weight: 700;
                    color: #fff;
                }
            }

            .content {
                margin-top: 28px;
                font-size: 14px;
                font-weight: 400;
                color: hsla(0, 0%, 100%, .8);
                line-height: 30px;
            }
        }
    }
}

.dad {
    height: 100%;
    display: flex;
    align-items: center;
    color: #07ecfe;
    cursor: pointer;
    padding-right: 16px;
}

.sdafasdf {
    cursor: pointer;
    margin-top: 16px;
    width: 100%;
    background: #07ecfe !important;
    border-radius: 4px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    padding: 12px 20px;
}

.infosty {
    overflow-y: auto;
    width: 100%;
}

.titlesty {
    height: 64px;
    line-height: 64px;
    border-bottom: 1px solid #2c313e;
    padding: 0 20px;
    color: #fff;
}

.MetaTrader5-bottom-content {
    text-align: center;
    min-height: 250px;
    padding: 20px 20px 0;

    .trend-head {
        height: 65px;
        line-height: 65px;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 2px;
        color: #fff;
        background-color: #1c222c;
        padding-left: 20px;

        .column {
            flex: 1;
        }
    }

    .scroll-wrap {
        .trend-body {
            .row {
                display: flex;
                align-items: center;
                justify-content: start;
                margin-bottom: 2px;
                font-size: 16px;
                padding-left: 20px;
            }

            .column {
                flex: 1;
                min-height: 69px;
                display: flex;
                align-items: center;
                justify-content: start;
            }
        }

        ol,
        ul {
            list-style: none;
        }
    }

    .bottom-more {
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: center;
        color: #888;
    }
}
</style>